export const TRANSLATIONS_ES_HOME_ACTIONS_AND_OVERVIEW = {
  "home.title": "Sistema de Retrieval-Augmented Generation",
  "home.lead":
    "Mejora las respuestas de modelos de lenguaje con información contextual de tus documentos.",
  "home.description":
    "Sube documentos, realiza consultas y obtén respuestas precisas basadas en tu propia información.",
  "home.upload_btn": "Subir Documentos",
  "home.query_btn": "Realizar Consulta",
  "home.feature_processing_title": "Procesamiento de Documentos",
  "home.feature_processing_desc":
    "Extrae texto de documentos PDF, Word y TXT almacenados en S3 o subidos directamente.",
  "home.feature_embeddings_title": "Embeddings y Vectorización",
  "home.feature_embeddings_desc":
    "Convierte texto en vectores utilizando modelos avanzados de embeddings para búsqueda semántica.",
  "home.feature_generation_title": "Generación de Respuestas",
  "home.feature_generation_desc":
    "Obtén respuestas precisas basadas en tus documentos utilizando modelos de lenguaje avanzados.",
  "home.general.loading": "Cargando telemetría...",
  "home.general.retry": "Reintentar",
  "home.general.retryAfter": "Reintentando en",
  "home.general.actionUnavailableTitle": "Acción no disponible",
  "home.general.actionUnavailableMessage": "No tenemos información suficiente para completar esta acción.",
  "home.pagination.previous": "Anterior",
  "home.pagination.next": "Siguiente",
  "home.shared.aiBadge": "Generado por IA",
  "home.shared.detectedBadge": "Detectado automáticamente",
  "home.shared.prioritizedBadge": "Priorizado por IA",
  "home.shared.recommendationBadge": "Recomendación prioritaria",
  "home.reasonCode.due_soon": "Vence pronto",
  "home.reasonCode.overdue": "Vencido",
  "home.reasonCode.high_priority": "Alta prioridad",
  "home.reasonCode.compliance_required": "Cumplimiento requerido",
  "home.reasonCode.needs_review": "Requiere revisión",
  "home.reasonCode.pending_review": "Pendiente de revisión",
  "home.decisionStates.act_now": "Actuar ahora",
  "home.decisionStates.act_soon": "Actuar pronto",
  "home.decisionStates.act_without_rush": "Puede esperar",
  "home.decisionStates.waiting": "Acción programada",
  "home.decisionStates.blocked": "Esperando información",
  "home.decisionStates.in_review": "En revisión",
  "home.decisionStates.dismissed": "Descartada",
  "home.decisionStates.safe_to_ignore": "Seguro ignorar",
  "home.decisionStates.completed": "Resuelta",
  "home.attention.sectionTitle": "Requiere atención",
  "home.attention.followUpTitle": "Seguimiento",
  "home.attention.allClearTitle": "Todo en orden",
  "home.attention.allClearCopy": "No hay decisiones que requieran tu atención en este momento.",
  "home.decisionDisplay.priority.critical.label": "Crítica",
  "home.decisionDisplay.priority.critical.copy": "Está vencida o puede generar impacto operativo.",
  "home.decisionDisplay.priority.high.label": "Alta",
  "home.decisionDisplay.priority.high.copy": "La fecha está próxima y requiere revisión.",
  "home.decisionDisplay.priority.medium.label": "Media",
  "home.decisionDisplay.priority.medium.copy": "Conviene revisarla pronto para evitar bloqueo o retraso.",
  "home.decisionDisplay.priority.low.label": "Baja",
  "home.decisionDisplay.priority.low.copy": "Puede mantenerse en seguimiento por ahora.",
  "home.decisionDisplay.risk.critical.label": "Riesgo crítico",
  "home.decisionDisplay.risk.critical.copy": "Puede interrumpir una operación importante o generar incumplimiento inmediato.",
  "home.decisionDisplay.risk.high.label": "Riesgo alto",
  "home.decisionDisplay.risk.high.copy": "Puede afectar pagos, cumplimiento o continuidad operativa.",
  "home.decisionDisplay.risk.medium.label": "Riesgo medio",
  "home.decisionDisplay.risk.medium.copy": "Puede generar retrasos, retrabajo o seguimiento adicional.",
  "home.decisionDisplay.risk.low.label": "Riesgo bajo",
  "home.decisionDisplay.risk.low.copy": "El impacto operativo es acotado si se revisa a tiempo.",
  "home.decisionDisplay.risk.none.label": "Riesgo por confirmar",
  "home.decisionDisplay.risk.none.copy": "Todavía no hay suficiente contexto para calificar el riesgo.",
  "home.decisionDisplay.confidence.high.label": "Alta confianza",
  "home.decisionDisplay.confidence.high.copy": "La recomendación es consistente con la evidencia disponible.",
  "home.decisionDisplay.confidence.medium.label": "Confianza media",
  "home.decisionDisplay.confidence.medium.copy": "Conviene revisar la evidencia clave antes de confirmar.",
  "home.decisionDisplay.confidence.low.label": "Baja confianza",
  "home.decisionDisplay.confidence.low.copy": "Revisa la evidencia antes de actuar.",
  "home.decisionActionUx.readyTitle": "Puedes actuar ahora",
  "home.decisionActionUx.readyCopy": "La decisión está lista para ejecutar su siguiente acción.",
  "home.decisionActionUx.completeMissingInfo": "Revisar información faltante",
  "home.decisionActionUx.missingInfoTitle": "Falta información requerida",
  "home.decisionActionUx.missingInfoCopy": "Revisa la información faltante en este panel y completa el dato en el documento o sistema origen antes de reintentar la acción.",
  "home.decisionActionUx.missingInfoReason": "La acción final seguirá bloqueada hasta que ese dato exista en el origen.",
  "home.decisionActionUx.reviewEvidence": "Revisar evidencia",
  "home.decisionActionUx.lowConfidenceTitle": "La recomendación necesita revisión",
  "home.decisionActionUx.lowConfidenceCopy": "La decisión no debería ejecutarse hasta revisar la evidencia y la confianza del resultado.",
  "home.decisionActionUx.lowConfidenceReason": "La confianza es insuficiente para ejecutar la acción final.",
  "home.decisionActionUx.reviewRecommendation": "Revisar recomendación",
  "home.decisionActionUx.catalogTitle": "La recomendación necesita validación",
  "home.decisionActionUx.catalogCopy": "La fuente de decisión no está lo bastante estable para ejecutar la acción final.",
  "home.decisionActionUx.catalogReason": "La recomendación se degradó y requiere revisión manual.",
  "home.decisionActionUx.resolveBlock": "Ver bloqueo",
  "home.decisionActionUx.blockedTitle": "Urgente, pero bloqueada",
  "home.decisionActionUx.blockedCopy": "La decisión importa ahora, pero no puede completarse hasta resolver el bloqueo.",
  "home.decisionActionUx.blockedReason": "Resuelve el bloqueo antes de ejecutar la acción final.",
  "home.decisionActionUx.waitingLabel": "Esperar actualización",
  "home.decisionActionUx.waitingTitle": "Aún no puedes actuar",
  "home.decisionActionUx.waitingCopy": "Esta decisión depende de una señal externa o de una actualización pendiente.",
  "home.decisionActionUx.waitingReason": "Home IA todavía está esperando una condición para habilitar la acción.",
  "home.decisionActionUx.confirmRequiredData": "Confirmar datos requeridos",
  "home.decisionActionUx.reviewRequirements": "Revisar requisitos",
  "home.decisionActionUx.disabledTitle": "La acción no está disponible",
  "home.decisionActionUx.disabledCopy": "La decisión necesita revisión antes de volver a habilitar la acción principal.",
  "home.decisionActionUx.completedTitle": "Decisión resuelta",
  "home.decisionActionUx.completedCopy": "No hay una acción pendiente para esta decisión.",
  "home.decisionActionUx.completedReason": "La decisión ya fue resuelta.",
  "home.decisionActionUx.safeToIgnoreTitle": "No requiere acción ahora",
  "home.decisionActionUx.safeToIgnoreCopy": "Puedes mantener esta decisión en observación sin intervenir.",
  "home.decisionActionUx.safeToIgnoreReason": "La decisión puede seguir en monitoreo sin acción inmediata.",
  "home.decisionActionUx.noActionTitle": "Sin acción confirmada",
  "home.decisionActionUx.noActionCopy": "Todavía no hay una acción confirmada para esta decisión.",
  "home.decisionSummary.eyebrow": "Estados",
  "home.decisionSummary.title": "Resumen de decisiones",
  "home.decisionList.eyebrow": "Inbox",
  "home.decisionList.title": "Lista compacta de decisiones",
  "home.decisionList.filteredTitle": "Decisiones filtradas",
  "home.decisionList.empty": "No hay decisiones para mostrar todavía.",
  "home.decisionList.emptyFiltered": "No hay decisiones en este estado.",
  "home.viewMode.current": "Vista actual",
  "home.viewMode.calendar": "Calendario",
  "home.decisionActionForm.title": "Datos requeridos",
  "home.decisionActionForm.selectPlaceholder": "Selecciona una opción",
  "home.decisionActionForm.required": "Completa este campo para continuar.",
  "home.decisionActionForm.confirmExecution": "Confirmo que esta acción operativa debe ejecutarse.",
  "home.decisionActionForm.confirmRequired": "Confirma la acción antes de continuar.",
  "home.decisionActionForm.submit": "Ejecutar acción",
  "home.decisionActionForm.cancel": "Cancelar",
};
